import jobEdit from './edit.vue'
import jobList from './list.vue'
import * as jobrun from './run.vue'

let a = Object.assign({ jobEdit, jobList},jobrun)
export default a
